import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { MainSlopePoints } from '../../../../../../../../core/types/types';
import { slopePointIcon } from '../../../../../../configs/map-icon.config';

interface MainSlopePointMarkersProps {
    mainSlopePoints: MainSlopePoints;
}
const MainSlopePointMarkers: React.FC<MainSlopePointMarkersProps> = ({ mainSlopePoints }) => {
    return (
        <>
            <Marker
                position={[mainSlopePoints.highest.lat, mainSlopePoints.highest.lng]}
                icon={slopePointIcon(mainSlopePoints.highest.color)}
            >
                <Popup closeButton={false} autoClose={false}>
                    <div>
                        ارتفاع:{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            {' '}
                            {mainSlopePoints.highest.elevation < 0
                                ? `${Math.abs(mainSlopePoints.highest.elevation)}-`
                                : mainSlopePoints.highest.elevation}
                        </span>{' '}
                        متر{' '}
                    </div>
                </Popup>
            </Marker>
            <Marker
                position={[mainSlopePoints.lowest.lat, mainSlopePoints.lowest.lng]}
                icon={slopePointIcon(mainSlopePoints.lowest.color)}
            >
                <Popup closeButton={false} autoClose={false}>
                    <div>
                        ارتفاع:{' '}
                        <span style={{ fontWeight: 'bold' }}>
                            {' '}
                            {mainSlopePoints.lowest.elevation < 0
                                ? `${Math.abs(mainSlopePoints.lowest.elevation)}-`
                                : mainSlopePoints.lowest.elevation}
                        </span>{' '}
                        متر از سطح دریا{' '}
                    </div>
                </Popup>
            </Marker>
        </>
    );
};

export default MainSlopePointMarkers;
